import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import Store from "../../../index";
import { api } from "@/lib";
import { ManufacturerResource } from "../../../../models/api/barcodeSystem/barcodeManufacturers/get";

const name = "barcodeManufacturer";

if (Store.state[name]) {
  Store.unregisterModule(name);
}

@Module({ name: name, dynamic: true, store: Store, namespaced: true, stateFactory: true })
export default class BarcodeManufacturerModule extends VuexModule {
  public loading: boolean = false;
  public error: boolean = false;
  public errorMessage: string = "";
  public manufacturers: ManufacturerResource[] = null;

  @Action
  async createManufacturer(payload) {
    return await api.postAsync("/barcode/manufacturers", payload);
  } 
  
  @Action
  async updateManufacturer(payload) {
    return await api.putAsync(`/barcode/manufacturers/${payload.code}`, payload);
  }

  @Action
  async deleteManufacturer(code) {
    return await api.deleteAsync(`/barcode/manufacturers/${code}`);
  }

  @Action
  async getManufacturers() {
    return await api.getAsync("/barcode/manufacturers");
  }  
  
  @Action
  async getManufacturer(code: string) {
    let response = await api.getAsync(`/barcode/manufacturers/${code}`);
    return response.data;
  }

  @Action
  async getManufacturersForCompanies(companyIds: number[]): Promise<ManufacturerResource[]> {
    if (!companyIds || companyIds.length < 1) return [];
    const query = companyIds.map(id => `companyIds=${id}`).join('&');
    const response = await api.getAsync(`/barcode/manufacturers?${query}`);
    return response.data;
  }

  @Action
  async loadManufacturers(): Promise<void> {
    const response = await this.getManufacturers();
    this.setManufacturers(response.data);
  }

  @Mutation
  setManufacturers(manufacturers: ManufacturerResource[]) {
    this.manufacturers = manufacturers;
  }
}
